import { useContext } from "react";
import { NearbyVenueContext } from "@/context/NearbyVenueContext";

export const useNearbyVenue = () => useContext(NearbyVenueContext);
